<template>
	<defaultTemplate>
		<div class="columns">
			<div class="column is-flex js-center ai-end" >
				<img src="@/assets/image.png">
			</div>
			<div class="column" :class="maxWidth > 768 ? '':'pd-2'">
				<div class="card rounded">
					<div class="card-content text-left pd-y-1">
					<ValidationObserver ref="observer" v-slot="{ passes }">
						<h1 class="text-center mg-b-2">กรุณากรอกรหัสผ่านใหม่</h1>
						<div class="mg-b-3">
							<BInputWithValidation
					         	
	                            rules="required|min:8"
	                            type="password"
	                            label="รหัสผ่านใหม่"
	                            vid="password"
	                            v-model="form.password"
	                        />
						</div>
				        <div class="mg-b-2">
	 						<BInputWithValidation
	                            rules="required|confirmed:password"
	                            name="Password"
	                            type="password"
	                            label="ยืนยันรหัสผ่านใหม่"
	                            v-model="form.confirmPassword"
	                        />
	                    </div>
				        <div class="text-center pd-b-1">
				        	<b-button @click="sendEmail" :style="styleObject">เปลี่ยนรหัสผ่าน</b-button>
				        </div>
				    </ValidationObserver>
				        <div class="mg-t-1 text-left">
				        	<router-link to="/">ย้อนกลับ</router-link>
				        </div>

					</div>
				</div>
			</div>
		</div>
	</defaultTemplate>
</template>
<script>
	import { ValidationObserver } from "vee-validate";
	import BInputWithValidation from "@/components/inputs/BInputWithValidation";
	import defaultTemplate from '@/template/DefaultTemplate'
	import { HTTP } from "@/service/axios.js";
	import {
		alertFailError,
		alertSuccess
	} from "@/service/alert";
	export default{
		components:{
			defaultTemplate,
			ValidationObserver,
        	BInputWithValidation
		},mounted() {
		    this.checkSecret();
		},methods:{
			checkSecret() {
		      HTTP.get(`check/code/${this.$route.params.secret}`)
		        .then(res => {
		          //console.log(`check/code/${this.$route.params.secret}`,res)
		          if (res.data.success) {
		          } else {
		            this.alertFailError();
		            this.$router.push("/forgot-password");
		          }
		        })
		        .catch(e => {
		          this.msgErrorValid = "เครือข่ายไม่เสถียร กรุณาติดต่อผู้ดูแล";
		          console.log("createAccount error", e);
		        })
		        .finally(() => {
		          this.isLoadingPage = false;
		        });
		    },
			sendEmail(){
				let obj = {
					code:this.$route.params.secret,
					passwd:this.form.password
				}
				HTTP.post('change/password',obj).then(res=>{
					if(res.data.success){
						this.$buefy.notification.open({
							duration: 5000,
		                    message: 'ดำเนินการสำเร็จ',
		                    type: 'is-success'
		                })
						this.$router.push("/signin");
            			
					}
					
				}).catch(e => {
		          this.msgErrorValid = "เครือข่ายไม่เสถียร กรุณาติดต่อผู้ดูแล";
		          console.log("createAccount error", e);
		        })
		        .finally(() => {
		          this.isLoadingPage = false;
		        });
			}
		},data() {
	        return {
	        	msgErrorValid:'',
	            form:{
	                email:'',
	                password:'',
	                confirmPassword:''
	            },
	            isLoadingPage:false
	        }
	    },
	}
</script>